<ng-container #formDirective="parent-form" thr-parent-form>
    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                {{ 'full-data.shareholders-company-25' | translate }}
            </h3>
            <mat-radio-group name="fdthlpYesNo" [(ngModel)]="client.hasMainShareHolders" (ngModelChange)="onHasMainShareHoldersChange()" [required]="true" [disabled]="isDisabled">
                <div class="row mb-3 mb-sm-4">
                    <div class="col-6 col-sm-3">
                        <mat-radio-button name="fdthlpNo" color="blue-gray" [value]="false">
                            {{ 'general.no' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-6 col-sm-3">
                        <mat-radio-button name="fdthlpYes" color="blue-gray" [value]="true">
                            {{ 'general.yes' | translate }}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>

            <div class="row" *ngIf="client.hasMainShareHolders">
                <div class="col-12">
                    <thr-full-data-shareholder-table [shareHolders]="client.shareHolders" [isDisabled]="isDisabled" (edit)="onEdit($event)" (remove)="onRemove($event)"></thr-full-data-shareholder-table>
                    <thr-full-data-form-shareholder-legal [shareHolder]="currentShareHolder" [isDisabled]="isDisabled" [showCancel]="client.shareHolders.length > 0" (cancel)="onCancel()" (save)="onSave()" *ngIf="adding || editing"></thr-full-data-form-shareholder-legal>
                    <div class="row justify-content-between" *ngIf="!isDisabled">
                        <ng-container *ngIf="!adding && !editing">
                            <div class="col-12 col-sm-6 col-md-4">
                                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray" (click)="onAdd(ShareHolderType.SHAREHOLDER)">
                                    {{ 'form.add-other-shareholder' | translate }}
                                </button>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 mt-3 mt-sm-0">
                                <button type="submit" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="client.shareHolders.length === 0">
                                    {{ 'general.save' | translate }}
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div class="row" *ngIf="client.hasMainShareHolders === false">
                <div class="col-12">
                    <h3 class="mat-subheading-1 text-blue font-weight-bold">
                        {{ 'full-data.natural-person-25' | translate }}
                    </h3>
                    <mat-radio-group name="fdthlpYesNoSecondary" [(ngModel)]="client.hasSecondaryShareHolders" (ngModelChange)="onHasSecondaryShareHoldersChange()" [required]="true" [disabled]="isDisabled">
                        <div class="row mb-3 mb-sm-4">
                            <div class="col-6 col-sm-3">
                                <mat-radio-button name="fdthlpNoSecondary" color="blue-gray" [value]="false">
                                    {{ 'general.no' | translate }}
                                </mat-radio-button>
                            </div>
                            <div class="col-6 col-sm-3">
                                <mat-radio-button name="fdthlpYesSecondary" color="blue-gray" [value]="true">
                                    {{ 'general.yes' | translate }}
                                </mat-radio-button>
                            </div>
                        </div>
                    </mat-radio-group>

                    <ng-container *ngIf="!client.hasSecondaryShareHolders">
                        <div class="row justify-content-end" *ngIf="!isDisabled">
                            <div class="col-12 col-sm-6 col-md-4">
                                <button type="submit" class="full-width mat-elevation-z0" mat-raised-button color="blue">
                                    {{ 'general.save' | translate }}
                                </button>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="client.hasSecondaryShareHolders">
                        <thr-full-data-shareholder-table [shareHolders]="client.shareHolders" [owner]="true" [isDisabled]="isDisabled" (edit)="onEdit($event)" (remove)="onRemove($event)"></thr-full-data-shareholder-table>
                        <thr-full-data-form-shareholder [shareHolder]="currentShareHolder" [owner]="true" [min]="0" [isDisabled]="isDisabled" *ngIf="adding || editing"></thr-full-data-form-shareholder>

                        <div class="row justify-content-between" *ngIf="!isDisabled">
                            <ng-container *ngIf="!adding && !editing">
                                <div class="col-12 col-sm-6 col-md-4">
                                    <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray" (click)="onAdd(ShareHolderType.CONTROLLER)">
                                        {{ 'form.add-other-shareholder-final' | translate }}
                                    </button>
                                </div>
                                <div class="col-12 col-sm-6 col-md-4 mt-3 mt-sm-0">
                                    <button type="submit" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="client.shareHolders.length === 0">
                                        {{ 'general.save' | translate }}
                                    </button>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="adding || editing">
                                <div class="col-12 col-sm-6 col-md-4">
                                    <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray" (click)="onCancel()" *ngIf="client.shareHolders.length > 0">
                                        {{ 'general.cancel' | translate }}
                                    </button>
                                </div>
                                <div class="col-12 col-sm-6 col-md-4 mt-3 mt-sm-0">
                                    <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!isFormValid" (click)="onSave()">
                                        {{ 'form.add-shareholder-final' | translate }}
                                    </button>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-container>
